import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../context/SnackbarContext";
import { useQuery } from "@tanstack/react-query";
import GatewayService from "../services/GatewayService";

function useGetContractingCompanies() {
  const { showSnackbar } = useSnackbarActionContext();

  const result = useQuery({
    queryKey: ["contracting-companies"],
    queryFn: () => GatewayService.getContractingCompanies(),
    retry: false,
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
  });

  return {
    ...result,
    contractingCompanies: result.data?.items || [],
  };
}

export { useGetContractingCompanies };
